export const createLogtoSignInOptions = (callbackUri: string) => ({
  redirectUri: callbackUri,
});
